import { ReactNode, createContext, useState } from 'react';
import { ObjectPendency } from '../objectScreen.types';

export interface ObjectPendenciesContextValue {
  pendencies: ObjectPendency[];
  isRevealed: boolean;
  reveal: () => void;
  hide: () => void;
  countBySection: (sectionKey: string) => number;
  hasPendency: (key: string) => boolean;
}

const NO_PENDENCIES: ObjectPendency[] = [];

export const ObjectPendenciesContext = createContext<ObjectPendenciesContextValue>({
  pendencies: NO_PENDENCIES,
  isRevealed: false,
  reveal: () => undefined,
  hide: () => undefined,
  countBySection: () => 0,
  hasPendency: () => false,
});

interface ObjectPendenciesProviderProps {
  objectId: string;
  pendencies: ObjectPendency[];
  children: ReactNode;
}

export const ObjectPendenciesProvider = ({
  objectId,
  pendencies,
  children,
}: ObjectPendenciesProviderProps) => {
  const [isRevealed, setIsRevealed] = useState(false);
  const [revealedObjectId, setRevealedObjectId] = useState(objectId);

  if (objectId !== revealedObjectId) {
    setRevealedObjectId(objectId);
    setIsRevealed(false);
  }

  const value: ObjectPendenciesContextValue = {
    pendencies,
    isRevealed,
    reveal: () => setIsRevealed(true),
    hide: () => setIsRevealed(false),
    countBySection: (sectionKey) =>
      !isRevealed ? 0 : pendencies.filter((pendency) => pendency.sectionKey === sectionKey).length,
    hasPendency: (key) => isRevealed && pendencies.some((pendency) => pendency.key === key),
  };

  return (
    <ObjectPendenciesContext.Provider value={value}>{children}</ObjectPendenciesContext.Provider>
  );
};
